import axios from 'axios';

export const apiRequester = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


